import * as Sentry from "@sentry/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import { DEFAULT_SENTRY_DSN } from "~/constants/sentry";
import { getRuntimeEnv } from "~/utils/getRuntimeEnv";
import { resolveSentryEnvironmentConfig } from "~/utils/sentryConfig";

// Runtime environment, not `import.meta.env.MODE` — the image is built once and promoted, so the
// build-time mode is "production" in every deployment. `window._env_` is populated by an inline
// script in the document head (see root.tsx Layout), which runs before this deferred module.
const { environment, enabled, tracesSampleRate, replaysSessionSampleRate } =
  resolveSentryEnvironmentConfig(
    getRuntimeEnv()?.VITE_ENVIRONMENT || import.meta.env.MODE,
    { isLocalDevBuild: import.meta.env.DEV }
  );

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || DEFAULT_SENTRY_DSN,
  environment,
  enabled,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate,
  replaysSessionSampleRate,
  // Always capture replays on errors
  replaysOnErrorSampleRate: 1.0,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
